import React from 'react';
import PropTypes from 'prop-types';
import {formatNumber} from "../utils/utils";
import {Table} from "./table/table";

export function Enterprises(props) {

    const sortAmount = React.useMemo(() => {
        return (rowA, rowB) => {
            if (rowA.original.totalFinancement >= rowB.original.totalFinancement) {
                return 1
            } else {
                return -1
            }
        }
    }, [])
    return (
        <Table
            location={props.location}
            data={props.enterprises}
            columns={[
                {
                    header: 'Dépt',
                    accessorKey: 'codeDepartement', // accessor is the "key" in the data
                    id: 'codeDepartement', // accessor is the "key" in the data
                    className: 'col-xs-1',
                },
                {
                    header: 'Nom',
                    accessorKey: 'denominationSociale',
                    id: 'denominationSociale',
                    className: 'col-xs-2',
                },
                {
                    header: 'Activités',
                    accessorKey: 'secteurActivite',
                    id: 'secteurActivite',
                    className: 'col-xs-2',
                },
                {
                    header: 'Utilité sociale',
                    accessorKey: 'finaliteSocietale',
                    id: 'finaliteSocietale',
                    className: 'col-xs-3',
                },
                {
                    header: 'Emplois créés',
                    accessorFn: (enterprise) => formatNumber(enterprise.totalEtpApres),
                    id: 'totalEtpApres',
                    className: 'col-xs-2',
                },
                {
                    header: 'Montant investi',
                    accessorFn: (enterprise) => `${formatNumber(enterprise.totalFinancement)} €`,
                    id: 'totalFinancement',
                    className: 'col-xs-2',
                    sortType: sortAmount
                },
            ]}
        />
    );
}

Enterprises.propTypes = {
    enterprises: PropTypes.arrayOf(
        PropTypes.shape({
            numeroStructure: PropTypes.number.isRequired,
            codeDepartement: PropTypes.string.isRequired,
            denominationSociale: PropTypes.string.isRequired,
            secteurActivite: PropTypes.string.isRequired,
            finaliteSocietale: PropTypes.string.isRequired,
            totalEtpApres: PropTypes.number.isRequired,
            totalEtpEnDifficulte: PropTypes.number.isRequired,
            totalFinancement: PropTypes.number.isRequired,
        })
    )
}